import React from 'react';
import { useState } from 'react';
import ButtonAppBar from './components/ButtonAppBar';
import RightDrawer from './components/RightDrawer';

function RootLayout() {
  const [drawerState, setDrawerState] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setDrawerState(open);
  };


  return (
    <>
      <ButtonAppBar toggleDrawer={toggleDrawer(true)} />
      <RightDrawer open={drawerState} toggleDrawer={toggleDrawer(false)} />
    </>
  );
}

export default RootLayout;
